import { withMetadata } from '../min/metadata'

import { searchPhoneNumbers as _searchPhoneNumbers } from '../es6/findPhoneNumbers'

export function searchPhoneNumbers() {
	return withMetadata(_searchPhoneNumbers, arguments)
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/libphonenumber-js/index.es6.exports/searchPhoneNumbers.js
// module id = 648
// module chunks = 0